// @ts-strict-ignore
import { isJSON } from './is-json';

export function conditionallyPrefixImagesWithFilesUrl(urlPath: string, baseUrlFiles: string): string {
  if (isJSON(urlPath)) {
    try {
      let json = JSON.parse(urlPath);
      json = json?.map((item) => {
        item.url = conditionallyPrefixWithFilesUrl(item.url, baseUrlFiles);
        return item;
      });
      return JSON.stringify(json);
    } catch (err) {
      console.warn(err);
      return '';
    }
  }
  return conditionallyPrefixWithFilesUrl(urlPath, baseUrlFiles);
}

export function conditionallyRemoveFilesUrlPrefixOnImages(url: string, baseUrlFiles: string): string {
  if (isJSON(url)) {
    try {
      let json = JSON.parse(url);
      json = json.map((item) => {
        item.url = conditionallyRemoveFilesUrlPrefix(item.url, baseUrlFiles);
        return item;
      });
      return JSON.stringify(json);
    } catch (err) {
      console.warn(err);
      return '';
    }
  }
  return conditionallyRemoveFilesUrlPrefix(url, baseUrlFiles);
}

function conditionallyPrefixWithFilesUrl(url: string, baseUrlFiles: string): string {
  if (url && !url?.startsWith('http') && !url?.startsWith('data:')) {
    return baseUrlFiles + url;
  }
  return url;
}

function conditionallyRemoveFilesUrlPrefix(url: string, baseUrlFiles: string): string {
  let path = url;
  if (url?.startsWith(baseUrlFiles)) {
    path = url.split(baseUrlFiles)[1];
  }
  return path ?? '';
}
